import {useMemo} from "react"

/**
 * call the given function once and return the result
 * ignores rerenders and changes to the function
 */
export function useOnce<A>(fn: () => A): A {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(fn, [])
}
